var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.359,
    height: 16.789,
    viewBox: "0 0 15.359 16.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    transform: "translate(-2.25 -1.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9939",
    "data-name": "Path 9939",
    d: "M11.129,3.269,4.808,9.96a2.348,2.348,0,0,0-.516,1.1l-.285,2.495a1.176,1.176,0,0,0,1.44,1.363l2.479-.423A2.211,2.211,0,0,0,9,13.917l6.321-6.691C16.411,6.071,16.9,4.755,15.2,3.146,13.508,1.552,12.222,2.114,11.129,3.269Z",
    transform: "translate(-0.229 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9940",
    "data-name": "Path 9940",
    d: "M11.89,5.05a4.717,4.717,0,0,0,4.2,3.965",
    transform: "translate(-2.045 -0.665)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9941",
    "data-name": "Path 9941",
    d: "M3,22H16.859",
    transform: "translate(0 -4.564)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f5f62d48660755a8c90aa2b253dfaae3.svg";
export { ForwardRef as ReactComponent };